import type {ReactElement} from 'react';
import styles from './skeleton-brick.module.scss';

export interface SkeletonBrickProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  radius?: string;
  theme?: SkeletonBrickTheme;
  isPulsating?: boolean;
}

export enum SkeletonBrickTheme {
  LIGHT = 'light',
  DARK = 'dark',
  LIGHT_TWO = 'light_two',
  AI_GRADIENT = 'ai_gradient',
  AI_ROTATING_GRADIENT = 'ai_rotating_gradient',
  AI_CYCLING_GRADIENT = 'ai_cycling_gradient',
}

export function SkeletonBrick({className = '', theme = SkeletonBrickTheme.LIGHT, isPulsating = true, ...props}: SkeletonBrickProps): ReactElement<any> {
  const getAnimationClassName = (): string => {
    switch (theme) {
      case SkeletonBrickTheme.DARK:
        return styles.dark;
      case SkeletonBrickTheme.LIGHT_TWO:
        return styles.lightTwo;
      case SkeletonBrickTheme.AI_GRADIENT:
        return styles.aiGradient;
      case SkeletonBrickTheme.AI_ROTATING_GRADIENT:
        return styles.rotatingGradient;
      case SkeletonBrickTheme.AI_CYCLING_GRADIENT:
        return styles.cyclingGradient;
      case SkeletonBrickTheme.LIGHT:
      default:
        return styles.light;
    }
  };

  const getStaticBrickClassName = (): string => {
    switch (theme) {
      case SkeletonBrickTheme.DARK:
        return styles.staticDark;
      case SkeletonBrickTheme.LIGHT_TWO:
        return styles.staticLightTwo;
      case SkeletonBrickTheme.AI_ROTATING_GRADIENT:
        return styles.rotatingGradient;
      case SkeletonBrickTheme.AI_CYCLING_GRADIENT:
        return styles.cyclingGradient;
      case SkeletonBrickTheme.LIGHT:
      default:
        return styles.staticLight;
    }
  };

  return (
    <div
      style={{
        width: props.width,
        height: props.height,
        borderRadius: props.radius,
      }}
      className={`${className} ${styles.skeletonContainer} ${isPulsating ? getAnimationClassName() : getStaticBrickClassName()} ${styles.dimensions}`}
    />
  );
}
